import axios from 'axios';
import { externalBaseUrl } from './constants';

export default function oAuth(guid, loginToken) {
    return axios({
        method: 'post',
        url: `${externalBaseUrl}/loginbydevice`,
        data: {
            token: loginToken,
            guid: guid,
        },
        // headers: {
        //   'Cache-Control': 'max-age=0, no-cache, must-revalidate, proxy-revalidate',
        // },
        timeout: 30000,
        withCredentials: false,
        maxContentLength: 128 * 1024 * 1024,
        dataType: 'json',
        contentType: 'application/json',
        accept: '*/*',
    }).then(({ data }) => data.token);
}
